import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {
    Grid,
    Text,
} from '@mantine/core';

import { useApplicationProducts } from '../hooks/useApplicationProducts';
import {
    useSearchParams
} from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { useEffect } from 'react';

import { IndexPageHeader } from '../components/IndexPageHeader';
import { IndexPageNavigation } from '../navigation/IndexPageNavigation';
import { BillingTabs } from '../components/BillingTabs';
import { ApplicationCard } from '../components/ApplicationCard';
import { BillingSetupCard } from '../../customers/components/BillingSetupCard';
import { useUserAccount } from '../../../../hooks/useUserAccount';


export const ProductsPage = () => {
    const [searchParams] = useSearchParams();
    const isSuccess = searchParams.get('success') === 'true';
    const { userAccount } = useUserAccount();

    const {
        applicationsWithPlans,
        statusByProductId,
        isLoading,
    } = useApplicationProducts();

    useEffect(() => {
        if (isSuccess) {
            notifications.show({
                title: 'Success',
                message: 'Your subscription has been activated successfully!',
                color: 'green'
            });
        }
    }, [isSuccess]);

    if (isLoading) {
        return <Text>Loading...</Text>;
    }

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader />}
            pageNavigation={<IndexPageNavigation />}
        >
            <SimplePageContentWrapper>
                {userAccount && !userAccount.customerId && (
                    <BillingSetupCard variant="banner" />
                )}
                <BillingTabs />

                {applicationsWithPlans.length > 0 ? (
                    <Grid gap="xl">
                        {applicationsWithPlans.map((appWithPlans) => (
                            <Grid.Col key={appWithPlans.application.id} span={{ base: 12, sm: 6, lg: 4 }}>
                                <ApplicationCard appWithPlans={appWithPlans} statusByProductId={statusByProductId} />
                            </Grid.Col>
                        ))}
                    </Grid>
                ) : (
                    <Text ta="center" c="dimmed">No applications available</Text>
                )}
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
